module.exports = __webpack_public_path__ + "img/banner1.2b8d9589.png";